/**
 * Step navigation.
 *
 * Default flow is next-in-array. A step's `branching` rules override: the
 * first rule whose `when` group matches sets the next step. The reserved
 * target "result" jumps to the result page. PLAN.md §8.5.
 */
import type { Answers, Step } from "../types";
import { matchGroup } from "./conditions";

export const RESULT = "result";

/** Resolve the next destination from `step`: a step id, or "result". */
export function nextDestination(step: Step, steps: Step[], answers: Answers): string {
  for (const rule of step.branching ?? []) {
    if (matchGroup(rule.when, answers)) return rule.goto;
  }
  const idx = steps.findIndex((s) => s.id === step.id);
  if (idx >= 0 && idx < steps.length - 1) return steps[idx + 1]!.id;
  return RESULT;
}

/** Look up a step by id; undefined if not found (or id is "result"). */
export function findStep(steps: Step[], id: string): Step | undefined {
  return steps.find((s) => s.id === id);
}

/**
 * Number of steps a user would traverse on the default (no-branch) path —
 * used for the progress indicator. Branching can shorten the actual path;
 * the bar is a best-effort estimate, not a guarantee.
 */
export function defaultPathLength(steps: Step[]): number {
  return steps.length;
}
